module.exports = __webpack_public_path__ + "static/image7@2x-270177ca517c5fe2fea3a610042f574b.png";